export const GSettings = {
    bEnaleLightprobes: true,
    bDebugLightprobes: false,
    bUseSRGB: false,
    EQuality: 2, //0 LQ 1 MQ 2 HQ
    bQualityChangeThisFrame: false,
};
